/**
 * Invoice Message Recipients Selector
 *
 * Selectors for transient member id's during invoice creation
 *
 */

export const selectInvoiceMessageRecipientIds = (state) => state.invoiceMessageRecipients.recipientIds;
